@if (showField$ | async) {
  <mat-form-field>
    <input matInput
      tabindex="-1"
      type="text"
      readonly="readonly"
      (click)="fieldClicked.emit(field)"
      [attr.name]="field.name"
      [placeholder]="field.placeholder | translate"
      [formControl]="$any(field.control)">
    @if (field.actionButton) {
      <button mat-button matSuffix
        [matTooltip]="field.actionButton.tooltip" aria-label="action"
        (click)="actionButtonClicked.emit(field)"
        >
        <mat-icon>{{ field.actionButton.icon }}</mat-icon>
      </button>
    }
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
